import { render, staticRenderFns } from "./titleLabel.vue?vue&type=template&id=540f1127&scoped=true"
import script from "./titleLabel.vue?vue&type=script&lang=js"
export * from "./titleLabel.vue?vue&type=script&lang=js"
import style0 from "./titleLabel.vue?vue&type=style&index=0&id=540f1127&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f1127",
  null
  
)

export default component.exports